const config = {
  development: {
    apiUrl: 'http://localhost:3000/api/v1/'
  },
  staging: {
    apiUrl: 'https://staging-compliance-api.current.us/api/v1/'
  },
  production: {
    apiUrl: 'https://compliance-api.current.us/api/v1/'
  }
};

export default config[process.env.REACT_APP_ENV || 'development'];
